import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';

@Component({
  selector: 'app-sync-favorites',
  templateUrl: './sync-favorites.component.html',
  styleUrls: []
})
export class SyncFavoritesComponent implements OnInit {
  @ViewChild(NgForm) userForm!: NgForm;
  @Input() userId: string;

  submitAttempt: boolean = false;
  filterCount: number = 0;
  users: PDxListItem<string>[] = [];
  userIds: string[] = [];

  userOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.users = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/User/DropDownList', { query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.users = data;
          }
        }, () => { });
      } else {
      }
      return false;
    },
    onChange: (ev: any) => {

    },
    /*buttons: [{
      text: 'clear', handler: (event) => {
        this.moveDetail.hierarchy = [];
        this.accountId = null;
        this.parentId = null;
      }
    }]*/
  };
  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    console.log(this.userIds);
    if (this.userIds.length > 0) {
      this.ajax.MakeCall('/User/SyncFavorites', { sourceUserId: this.userId, targetUserIds: this.userIds }).then(() => {
        this.modal.close();
      }, () => { });
    }
  }
}
